import React, { useEffect, useState,useContext } from "react";
import { openDB } from "idb";
import styles from "../css/SetupForm.module.css";
import Context from "../context/context"
import plusIcon from "../images/plus.svg";
import { v4 as uuidv4 } from "uuid";
import UserRolePopup from "./UserRolePopup";
const RoleManagmentSetup = ({ onSave }) => {
  const [roles, setRoles] = useState({});
  const [newRoles, setNewRoles] = useState([]);
  const [updatedRoles, setUpdatedRoles] = useState([]);
  const [editPopup, setEditPopup] = useState(false);
  const [roleInfo, setRoleInfo] = useState({});
  const context = useContext(Context);
  const {
    updateUnSync
  } = context;

  useEffect(() => {
    const getData = async () => {
      let DBOpenReq = indexedDB.open("FoodDo", +localStorage.getItem("IDBVersion") || 1);
      DBOpenReq.addEventListener("error", (err) => {
        console.warn(err);
      });
      DBOpenReq.addEventListener("success", (ev) => {
        let tx = ev.target.result.transaction("role_management", "readwrite");
        let store = tx.objectStore("role_management");
        let getReq = store.getAll();
        getReq.onsuccess = (outletReq) => {
          var outlet = outletReq.target.result;
          setRoles(outlet);
        };
      });
    };
    getData();
  }, []);
  
  const addRoles = () => {
    let id = uuidv4();
    setNewRoles([
      ...newRoles,
      {
        IDENTIFIER: id,
        restrictions: [{
          running_order_editing: "0",
          running_order_price: "0",
          running_order_edit_item_qty: "0",
          running_order_item_status: "1",
          running_order_delete: "0",
          running_order_add_item: "0",

          complete_order_editing: "0",
          complete_order_price: "0",
          complete_order_edit_item_qty: "0",
          complete_order_item_status: "1",
          complete_order_change_working_day: "0",
          complete_order_delete: "0",
          complete_order_add_item: "0",

          other_menu_and_seat: "0",
          other_menu_open_and_edit: "0",
          other_menu_and_seat_open_menu_and_edit: "0",
          other_menu_and_seat_new_edit_seat_section: "0",
          other_users: "0",

          other_report_Daily_summary: "3 days",
          other_report_order: "3 days",
          other_report_customer: "1",
          other_report_item_sale: "3 days",

          other_quick_access_item_availability: "1",

          other_setup_page_setup: "0",
          other_setup_delivery_setup: "0",
          other_setup_fixed_charges_and_discount: "0",
          other_setup_invoice_setup: "0",
          other_setup_kot_setup: "0",
          other_setup_meal_scheduling: "0",
          other_setup_outlet_details: "0",
          other_setup_payment_mode: "0",
          other_setup_pickup_setup: "0",
          other_setup_role_management: "0",
        }
        ],
        role_name: "",
        outlet_uuid: localStorage.getItem("outlet_uuid"),
        role_uuid: id,
      },
    ]);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const db = await openDB("FoodDo", +localStorage.getItem('IDBVersion') || 1);
    const store = db.transaction("role_management", "readwrite").objectStore("role_management");
    updatedRoles.forEach((item, i) => {
      const nData = {
        ...item,
      }
      const data = {
        ...nData,
        RECON_TIME: Date.now(),
        IDENTIFIER: `role-edit:${item.role_uuid}`,
      }
      store.put(nData);
      handleRoleUnsyncedFile(data);
    });

    newRoles.filter((item) => item.role_name !== "")?.forEach((item, i) => {
      const nData = {
        ...item,
      }
      const data = {
        ...nData,
        RECON_TIME: Date.now(),
        IDENTIFIER: `role-new:${item.role_uuid}`,
      }
      store.put(nData);
      handleRoleUnsyncedFile(data);
    });
    onSave();
  };

  // Adding/Editing Role to unsynced_files collection in IndexedDB
  const handleRoleUnsyncedFile = async (data) => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const tx = await db.transaction("unsynced_files", "readwrite").objectStore("unsynced_files");
    await tx.put({
      ...data, APPROVED: 1,
      BACKUP: 0
    });
   
      updateUnSync()
    
  };



  return (
    <>
      <form className={styles.form} onSubmit={handleSubmit}>
        <div className={styles.heading}>
          <h1>Roles Management Setup</h1>
        </div>

        <div className={styles.formContainer}>
          <div className={styles.formGroup} >
            {roles?.length ?
              roles?.map((role, index) => (
                <div className={styles.row} key={index}>
                  <label className={styles.selectLabel}>
                    Role Name
                    <input
                      className={styles.numberInput}
                      value={role?.role_name}
                      onChange={(e) => {
                        setRoles([
                          ...roles.map((item, i) => {
                            if (item._id === role._id) {
                              return {
                                ...item,

                                role_name: e.target.value,
                              };
                            } else {
                              return item;
                            }
                          }),
                        ]);
                        if (
                          updatedRoles?.filter((item) => item._id === role._id)
                            .length === 0
                        ) {
                          setUpdatedRoles([
                            ...updatedRoles,
                            ...roles
                              .filter(
                                (itemfilter, i) => itemfilter._id === role._id
                              )
                              .map((item, i) => {
                                if (item._id === role._id) {
                                  return {
                                    ...item,

                                    role_name: e.target.value,
                                  };
                                } else {
                                  return item;
                                }
                              }),
                          ]);
                        } else {
                          setUpdatedRoles([
                            ...updatedRoles.map((item, i) => {
                              if (item._id === role._id) {
                                return {
                                  ...item,
                                  role_name: e.target.value,
                                };
                              } else {
                                return item;
                              }
                            }),
                          ]);
                        }
                      }}
                    />
                  </label>
                  <button
                    style={{ width: "70px", height: "40px", margin: "20px" }}
                    className={styles.submit}
                    onClick={() => {
                      setRoleInfo({type:"edit",...role})
                      setEditPopup(true)
                    }}
                    type="button"
                  >
                    Edit
                  </button>
                </div>
              )) : <div />}
            {newRoles?.length ? (
              newRoles?.map((role, index) => (
                <div className={styles.row} key={index}>
                  <label className={styles.selectLabel}>
                    Role Name
                    <input
                      type="text"
                      name="role_name"
                      className={styles.numberInput}
                      style={{ width: "12rem" }}
                      value={role?.role_name}
                      onChange={(e) =>
                        setNewRoles([
                          ...newRoles.map((item, i) => {
                            if (item._id === role._id) {
                              return {
                                ...item,
                                role_name: e.target.value,
                              };
                            } else {
                              return item;
                            }
                          }),
                        ])
                      }
                    />
                  </label>
                  <button
                    style={{ width: "70px", height: "40px", margin: "20px" }}
                    className={styles.submit}
                    onClick={() => {
                      setRoleInfo({ type: "new", ...role })
                      setEditPopup(true)
                    }}
                    type="button"
                  >
                    Edit
                  </button>
                </div>
              ))
            ) : (
              <div />
            )}
            <button
              className={styles.addMealButton}
              onClick={addRoles}
              type="button"
            >
              <img src={plusIcon} alt='plus' />
            </button>
          </div>

          <button type="submit" className={styles.submit}>
            Save changes
          </button>
        </div>
      </form>
      {editPopup ? <UserRolePopup roleInfo={roleInfo} close={() => setEditPopup(false)} setNewRoles={setNewRoles} newRoles={newRoles} setRoles={setRoles} roles={roles}/> : ""}
    </>
  );
};

export default RoleManagmentSetup;
